import axios from "axios";
import qs from "qs";
import that from "../main";
import {
    hideLoading,
    showPartLoading
} from "../comon/plugins/loading";

// 不需要loading动画的请求, 就往这个数组添加
const cancalLoadingList = ["start-available-time", "end-available-time"];
// 局部loading动画的请求, 就往这个数组添加
const partLoadingList = ["/v1/user", "/v1/probation", "/v1/attendance", "/v1/project", "/v1/job", "/v1/meeting", "/v1/events", "/v1/recruitment", "/v1/interview", "/v1/commodity", "/v1/publish-log"];

let retry_401 = false;

const $http = axios.create({
    // 开发环境
    baseURL: process.env.VUE_APP_BASE_API,
    // 测试环境
    // baseURL: 'http://oa-uat-api.loratech.cn/api',

    timeout: 60000,
    responseType: "json",
    headers: {
        "Content-Type": "application/x-www-form-urlencoded"
    }
});

// 请求qs序列化;
$http.interceptors.request.use(
    config => {
        const token = localStorage.getItem("token");
        // 处理会议记录选择开始和结束时间时 , 会闪烁的问题
        /* var result = cancalLoadingList.every(item=>{
            return config.url.indexOf(item)==-1
        })
        if(result){
            showLoading();
        } */
        // 局部刷新的接口列表
        const partResult = partLoadingList.some(item => {
            return (
                config.url.indexOf(item) != -1 &&
                config.params &&
                config.params.page
            );
        });
        partResult && showPartLoading();
        if (
            config.headers["Content-Type"] ===
            "application/x-www-form-urlencoded"
        ) {
            config.data = qs.stringify(config.data, {
                arrayFormat: "indices",
                    allowDots: false
            });
        }
        if (token) {
            config.headers.token = token;
            // config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
        }
        return config;
    },
    error => {
        that.$message.error(error && error.data.error_msg);
        return Promise.reject(error.data.error_msg);
    }
);

// 接收数据，刷新token，封装res.bus_json
$http.interceptors.response.use(
    res => {
        let resD = res.data;

        if (resD) {
            switch (resD.code) {
                case 401:
                case 400:
                    that.$message.error("验证失败，请重新登录");
                    // localStorage.clear();
                    // localStorage.removeItem("token");
                    // setTimeout(() => {
                    //     that.$router.push({
                    //         path: "/login"
                    //     });
                    // }, 1000);
                    const token = localStorage.getItem('token');
                    localStorage.removeItem('token');
                    location.href = `${process.env.VUE_APP_AUTH_URL}/user/login?redirect=${encodeURIComponent(location.href)}&ot=${token}&st=${resD.code}`;
                    // hideLoading();
                    // break;
                    return;
                // case 400:
                //     that.$message.error("错误请求");
                //     // localStorage.clear();
                //     // localStorage.removeItem("token");
                //     // location.href = `${process.env.VUE_APP_AUTH_URL}/user/login?redirect=${encodeURIComponent(location.href)}&ot=${ot}`;
                //     // setTimeout(() => {
                //     //     that.$router.push({
                //     //         path: "/login"
                //     //     });
                //     // }, 1000);
                //     hideLoading();
                //     return;
                case 200:
                    hideLoading();
                    return resD;
                case 405:
                    that.$message.error(
                        "不被允许的方法。 请检查 Allow header 允许的HTTP方法。"
                    );
                    // localStorage.clear();
                    // localStorage.removeItem("token");
                    // location.href = `${process.env.VUE_APP_AUTH_URL}/user/login?redirect=${encodeURIComponent(location.href)}`;
                    // setTimeout(() => {
                    //     that.$router.push({
                    //         path: "/login"
                    //     });
                    // }, 1000);
                    hideLoading();
                    // break;
                    return;
                case 422:
                    that.$message.error(resD.msg);
                    hideLoading();
                    return false;
                default:
                    //其他默认返回的blob文件流
                    return res.data;
            }
        }
    },
    err => {
        // const originalConfig = err.config;
        if ([400, 401].includes(err.response.status)) {
            const token = localStorage.getItem('token');
            localStorage.removeItem('token');
            location.href = `${process.env.VUE_APP_AUTH_URL}/user/login?redirect=${encodeURIComponent(location.href)}&ot=${token}&st=${err.response.status}`;
            // if (originalConfig.url.indexOf("/refresh_token") === -1 && !retry_401) {
            //     retry_401 = true;
            //     if (localStorage.getItem('token') && (new Date(localStorage.getItem('expire')).getTime() > (new Date()).getTime() - 120000)) {
            //         // refresh
            //         $http.request('/../refresh_token').then((res) => {
            //             console.log('refresh_token', res);
            //             for (const key in res) {
            //                 localStorage.setItem(key, res[key] instanceof Object && JSON.stringify(res[key]) || res[key]);
            //             }
            //             originalConfig.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
            //             return $http(originalConfig);
            //         }, function error() {
            //             location.href = loginUrl;
            //             return Promise.reject(err);
            //         });
            //     } else {
            //         location.href = loginUrl;
            //     }
            // } else {
            //     location.href = loginUrl;
            // }

            return Promise.reject(err);
        }

        // console.log(err);
    }
);

export default $http;
